import { useEffect, useRef, useState } from "react";
import { MapPin, X } from "lucide-react";
import * as XLSX from "xlsx";
import { useStateValue } from "../../context/StateProvider";
import { deleteApp, initializeApp } from "firebase/app";
import { firebaseConfig, firestored } from "../../firebase/firebaseConfig";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import DealCard from "./deal-card";
import moment from "moment";

const BulkUploadDeals = ({ onClose, onSubmit }) => {
  const [{ user, employees, teamleads }, dispatch] = useStateValue();

  const [Data, setData] = useState([]);

  const [loading, setloading] = useState(false);

  function parseClientString(clientStr) {
    if (!clientStr) return [];

    const jsonSafe = clientStr.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');

    return JSON.parse(jsonSafe);
  }

  // function toISODate(dateStr) {
  //   const normalized = normalizeExcelDate(dateStr);
  //   const [month, day, year] = normalized.toString().split("/");

  //   return year + "-" + month + "-" + day;
  // }

  // function normalizeExcelDate(value) {
  //   // Excel serial date
  //   if (typeof value === "number") {
  //     return new Date((value - 25569) * 86400 * 1000)
  //       .toISOString()
  //       .split("T")[0];
  //   }

  //   // Already a string date
  //   if (typeof value === "string") {
  //     return value;
  //   }

  //   return "";
  // }

  function toISODate(value) {
    // if (!value) return "";

    // // Case 1: Excel serial number
    // if (typeof value === "number") {
    //   return new Date((value - 25569) * 86400 * 1000)
    //     .toISOString()
    //     .split("T")[0];
    // }

    // if (typeof value === "string") {
    //   // Case 2: YYYY-MM-DD (already correct)
    //   if (value.includes("-")) {
    //     return value;
    //   }

    //   // Case 3: DD/MM/YYYY
    //   if (value.includes("/")) {
    //     const parts = value.split("/");
    //     if (parts.length === 3) {
    //       const [day, month, year] = parts;
    //       return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    //     }
    //   }
    // }

    // return "";

    if (!value) return "";

    // Case 1: Excel serial number
    if (typeof value === "number") {
      const date = new Date(Math.round((value - 25569) * 86400 * 1000));
      return date.toISOString().split("T")[0];
    }

    if (typeof value === "string") {
      const trimmed = value.trim();

      // Case 2: Already ISO format YYYY-MM-DD
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return trimmed;
      }

      // Case 3: MM/DD/YYYY (Excel default)
      if (trimmed.includes("/")) {
        const [month, day, year] = trimmed.split("/");

        if (month && day && year) {
          return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }
      }
    }

    return "";
  }

  function normalizeCommission(value) {
    if (typeof value === "number") {
      return value * 100;
    }

    if (typeof value === "string") {
      return Number(value.replace("%", ""));
    }

    return 0;
  }
  const calculatecommission = (agentcasestep4data) => {
    let data = { ...agentcasestep4data };

    data.totalCommissionamount = data.flatfee
      ? data.flatfeeamount != ""
        ? parseFloat(data.flatfeeamount)
        : 0
      : (data.offerPrice / 100) *
        (data.totalcommissionrate != "" ? data.totalcommissionrate : 0);

    data.totalCommissionamount = data.totalCommissionamount?.toFixed(2);

    // data.totalCommissionamount =
    //   (data.offerPrice / 100) * data.totalcommissionrate;

    // data.totalCommissionamount = data.totalCommissionamount?.toFixed(2);

    if (data.captype == "pre") {
      if (data.splittype === "Referral") {
        if (data.leadCommission > 0) {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            data.thirdpartyagentCommission
          ).toFixed(2);
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            data.leadCommission
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission - leadcommission;

          data.bankcommission = ((takehomecommission / 100) * 10).toFixed(2);

          // data.takehomecommissionamount =
          //   takehomecommission - data.bankcommission;
          // data.takehomecommissionamount = takehomecommission;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == data.agentid)?.role == "Employee"
              ? takehomecommission
              : takehomecommission - data.bankcommission;
        } else {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            data.thirdpartyagentCommission
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission;

          data.bankcommission = ((takehomecommission / 100) * 10).toFixed(2);
          // data.takehomecommissionamount =
          //   takehomecommission - data.bankcommission;

          // data.takehomecommissionamount = takehomecommission;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == data.agentid)?.role == "Employee"
              ? takehomecommission
              : takehomecommission - data.bankcommission;
        }
      } else {
        if (data.leadCommission > 0) {
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            data.leadCommission
          ).toFixed(2);
          let takehomecommission = data.totalCommissionamount - leadcommission;

          data.bankcommission = ((takehomecommission / 100) * 10).toFixed(2);
          // data.takehomecommissionamount =
          //   takehomecommission - data.bankcommission;
          // data.takehomecommissionamount = takehomecommission;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == data.agentid)?.role == "Employee"
              ? takehomecommission
              : takehomecommission - data.bankcommission;
        } else {
          data.bankcommission = (
            (data.totalCommissionamount / 100) *
            10
          ).toFixed(2);
          // data.takehomecommissionamount =
          //   data.totalCommissionamount - data.bankcommission;
          // data.takehomecommissionamount = data.totalCommissionamount;
          data.takehomecommissionamount =
            employees.find((emp) => emp.id == data.agentid)?.role == "Employee"
              ? data.totalCommissionamount
              : data.totalCommissionamount - data.bankcommission;
        }
      }
    } else {
      data.bankcommission = 0;

      if (data.splittype === "Referral") {
        if (data.leadCommission > 0) {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            data.thirdpartyagentCommission
          ).toFixed(2);
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            data.leadCommission
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission - leadcommission;

          data.takehomecommissionamount = takehomecommission;
        } else {
          let thirdpartcommission = (
            (data.totalCommissionamount / 100) *
            data.thirdpartyagentCommission
          ).toFixed(2);
          let takehomecommission =
            data.totalCommissionamount - thirdpartcommission;

          data.takehomecommissionamount = takehomecommission;
        }
      } else {
        if (data.leadCommission > 0) {
          let leadcommission = (
            (data.totalCommissionamount / 100) *
            data.leadCommission
          ).toFixed(2);
          let takehomecommission = data.totalCommissionamount - leadcommission;

          data.takehomecommissionamount = takehomecommission;
        } else {
          data.takehomecommissionamount =
            (data.offerPrice / 100) * data.totalcommissionrate;
        }
      }
    }

    /////////////lead source commission/////
    data.leadsourceCommissionamount = (
      (data.totalCommissionamount / 100) *
      data.leadCommission
    ).toFixed(2);

    /////////////thirdparty agent commission/////

    data.thirdpartyagentcommissionamount = (
      (data.totalCommissionamount / 100) *
      data.thirdpartyagentCommission
    ).toFixed(2);

    /////////////team lead commission/////

    // data.teamleadCommissionamount = (
    //   (data.takehomecommissionamount / 100) *
    //   (100 - data.agentCommission)
    // ).toFixed(2);

    data.teamleadCommissionamount =
      data.captype == "pre"
        ? (
            (data.takehomecommissionamount / 100) *
            (employees.find((emp) => emp.id == data.agentid)?.role == "Employee"
              ? 100 - data.agentCommission - 10
              : 100 - data.agentCommission)
          ).toFixed(2)
        : (
            (data.takehomecommissionamount / 100) *
            (100 - data.agentCommission)
          ).toFixed(2);

    /////////////in house agent commission/////

    data.agentCommissionamount = (
      (data.takehomecommissionamount / 100) *
      data.agentCommission
    ).toFixed(2);

    return data;
  };

  const getLatLngFromAddress = async (address) => {
    const API_KEY = "AIzaSyClMaFJLo3buNYK-siytTa6AWD_72TgrE8";

    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address,
    )}&key=${API_KEY}`;

    const res = await fetch(url);
    const data = await res.json();

    console.log("Geocode response:", data);

    if (data.status === "OK") {
      const location = data.results[0].geometry.location;
      return {
        lat: location.lat,
        lng: location.lng,
      };
    } else {
      return {
        lat: 0,
        lng: 0,
      };
    }

    // const res = await fetch(
    //   `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
    //     address
    //   )}`
    // );

    // const data = await res.json();

    // if (data.length > 0) {
    //   return {
    //     lat: parseFloat(data[0].lat),
    //     lng: parseFloat(data[0].lon),
    //   };
    // } else {
    //   return {
    //     lat: 0,
    //     lng: 0,
    //   };
    // }
  };

  const findAgent = (agentName) => {
    if (!agentName) return null;

    const parts = agentName.trim().split(/\s+/);

    // 1️⃣ Try FIRST + LAST name match
    if (parts.length >= 2) {
      const [firstName, lastName] = parts;

      const fullMatch = employees.find(
        (e) =>
          e.firstname?.toLowerCase() === firstName.toLowerCase() &&
          e.lastname?.toLowerCase() === lastName.toLowerCase(),
      );

      if (fullMatch) return fullMatch;
    }

    // 2️⃣ Fallback: FIRST name only
    return employees.find(
      (e) => e.firstname?.toLowerCase() === parts[0].toLowerCase(),
    );
  };

  function formatPhone(value) {
    const digits = value.replace(/\D/g, "").slice(0, 10);

    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // Read first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert to JSON
      let jsonData = XLSX.utils.sheet_to_json(sheet);

      let newdata = [];

      for (const key in jsonData) {
        if (jsonData[key].Client) {
          jsonData[key].Client = "[" + jsonData[key].Client + "]";
          jsonData[key].Client = parseClientString(jsonData[key].Client);
        }
      }
      // console.log("THis is all the data " + JSON.stringify(jsonData));

      jsonData.forEach(async (item) => {
        // const selectedagent = employees.find(
        //   (data) => data.firstname === item.AgentName
        // );

        const selectedagent = findAgent(item.AgentName);
        const selectedteamlead = teamleads.find(
          (data) => data.firstname.trim() === item.TeamLead.trim(),
        );

        let clientdata = [...item.Client];
        for (const key in clientdata) {
          clientdata[key].phone = formatPhone(clientdata[key].phone);
        }

        let datset = {
          status: "Approved",
          propertyphoto: "",
          dealtype: item.ClientType || "",
          customers: clientdata,
          dealStage: item.DealStage,
          financingType: item.FinancingType || "",
          earnestMoney: item.EarnestMoney || "",
          // mlsNumber: item.MLSNumber || "",
          offerPrice: item.SalesPrice,
          propertyType: item.PropertyType || "",
          agentCommission: item.AgentCommission
            ? normalizeCommission(item.AgentCommission).toString()
            : "",
          brokeradminfee: item.BrokerAdminFee || 0,
          captype: item.Type?.toLowerCase() || "pre",
          captypedescription:
            item.Type == "Post"
              ? "Post-Cap (100% Commission)"
              : "Pre-Cap (90/10 Split)",
          closingdate: item.ClosingDate
            ? toISODate(item.ClosingDate)
            : toISODate(moment(new Date()).format("YYYY-MM-DD")),
          inspection: item.Inspection || "",
          inspectionDeadline: item.InspectionDeadline || "",
          financingDeadline: item.FinancingDeadline || "",
          leadsource: item.leadsource || "",
          leadCommission: "0",
          propertyaddress: item.Propertyaddress,
          thirdpartyagentCommission: item.ReferalAgentCommission || "0",
          thirdpartyagentName: item.ReferalAgentName || "",
          totalcommissionrate: item.TotalCommissionRate || 3.3,
          flatfee: item.CommissionType == "Yes" ? true : false,
          flatfeeamount: item.FixedAmount || 0,
          splittype: item.SplitType || "NoSplit",
          splitdescription:
            item.SplitType == "Referral"
              ? "Referral to Outside Agent"
              : item.SplitType == "TeamSplit"
                ? "Team Member Split"
                : "No Split",
          agentName: item.AgentName || "",
          teamleadName: item.TeamLead || "",
          agentData: selectedagent ? selectedagent.id : "",
          assignedteamlead: selectedteamlead ? selectedteamlead.id : "",
          buyersidecommissionrate: "",
          sellersidecommissionrate: "",
          teamleadcommissionrate: "",
          agentCommissionamount: 0,
          bankcommission: 0,
          leadsourceCommissionamount: 0,
          takehomecommissionamount: 0,
          teamleadCommissionamount: 0,
          thirdpartyagentcommissionamount: 0,
          totalCommissionamount: 0,
          createdby: user.id,
        };

        // /////////////lead source commission/////
        // step4data.leadsourceCommissionamount = (
        //   (step4data.totalCommissionamount / 100) *
        //   datset.leadCommission
        // ).toFixed(2);

        // /////////////team lead commission/////

        // step4data.teamleadCommissionamount = (
        //   (step4data.takehomecommissionamount / 100) *
        //   (100 - datset.agentCommission)
        // ).toFixed(2);

        // /////////////cold wall bank commission/////
        // step4data.bankcommission = step4data.bankcommission;

        // /////////////in house agent commission/////

        // step4data.agentCommissionamount = (
        //   (step4data.takehomecommissionamount / 100) *
        //   datset.agentCommission
        // ).toFixed(2);

        // /////////////thirdparty agent commission/////

        // step4data.thirdpartyagentcommissionamount = (
        //   (step4data.totalCommissionamount / 100) *
        //   datset.thirdpartyagentCommission
        // ).toFixed(2);

        const calculateddata = calculatecommission(datset);

        newdata.push(calculateddata);
      });

      console.log(JSON.stringify(newdata));
      setData(newdata);
    };
    reader.readAsBinaryString(file);
  };

  function heading(title, required) {
    return (
      <div className="flex flex-row mb-1">
        <label className="block font-medium text-sm ">{title}</label>
        {required && (
          <label className="block font-medium text-sm text-red-700 ml-[2px] ">
            *
          </label>
        )}
      </div>
    );
  }

  function stats(title, description) {
    return (
      <div className="lg:w-[32%] flex  flex-col items-center mb-4">
        <p className="text-black/50 text-center font-medium">{title}</p>
        <p className=" text-sm font-semibold text-black">
          {description || "-"}
        </p>
      </div>
    );
  }

  function dealinfo(title, description) {
    return (
      <div className="flex flex-col items-center">
        <span className="text-xs text-gray-500 mb-1">{title}</span>
        <span className="font-normal text-slate-900">{description}</span>
      </div>
    );
  }

  function userCard(userdetails) {
    return (
      <div className="bg-white rounded-2xl shadow-sm p-6 hover:shadow-lg hover:-translate-y-1 transition cursor-pointer border border-gray-200">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 border-y border-gray-200 py-4 mb-4">
          {dealinfo(
            "Full Name",
            userdetails.firstname + " " + userdetails.lastname,
          )}

          {dealinfo("Email", userdetails.email)}
          {dealinfo("Phone Number", userdetails.phonenumber)}
          {dealinfo(
            "Role",
            userdetails.role == "Admin"
              ? "Team Lead"
              : userdetails.role == "Supervisor"
                ? "Client Care"
                : "Employee",
          )}
        </div>
      </div>
    );
  }

  async function uploaduserdata() {
    setloading(true);

    try {
      // ✅ Create a completely new secondary auth instance

      for (const key in Data) {
        try {
          let locationlatlong = await getLatLngFromAddress(
            Data[key].propertyaddress,
          );

          let dataset = {
            createdat: Date.now(),
            propertyLocation: locationlatlong ? locationlatlong : "",
            ...Data[key],
          };
          await setDoc(
            doc(firestored, "deals", dataset.createdat.toString()),
            dataset,
          );
          toast.success(dataset.propertyaddress + " created successfully!");
        } catch (error) {
          console.log("Error creating deal:", error);
          toast.error(error.message);
        } finally {
        }
      }
    } catch (error) {
      console.log("global error creating user:", error);
      toast.error(error.message);
      setloading(false);
    } finally {
      setData([]);
      setloading(false);
      onClose();
    }
  }
  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[70%] h-[85%]  bg-white relative">
          {loading && (
            <div className="position absolute h-full w-full bg-black/50 flex justify-center items-center">
              <div role="status" className="">
                <svg
                  aria-hidden="true"
                  class="size-10 text-gray-200 animate-spin dark:text-white fill-[#1E293B]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10 h-[12%] bg-[#1E293B] text-white ">
            <div>
              <h2 className="text-xl font-semibold">Bulk Deal Creation</h2>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          {/* {Data.length > 0 && (
            <div className="flex items-center justify-between py-2 px-[14px]">
              <div>
                <h2 className="text-lg font-semibold text-indigo-600">
                  {"Users Found - " + Data.length}
                </h2>
              </div>
            </div>
          )} */}
          <div className="w-full  h-[78%]  overflow-y-auto form-scrollbar py-2 ">
            {Data.length > 0 ? (
              <div className="grid gap-6">
                {Data.map((item, i) => {
                  return (
                    <div className="w-full px-[10px]">
                      {
                        <DealCard
                          data={item}
                          isShowApprove={true}
                          viewdetails={false}
                          // isShowEdit={true}
                          // onEdit={(dealData) => handleOnEdit(dealData)}
                          // onAprove={(dealData) => handleOnApprove(dealData)}
                        />
                      }
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="w-full px-[20px] py-[20px]">
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleFileUpload}
                />
              </div>
            )}
          </div>
          {Data.length > 0 && (
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 h-[10%] px-[10px]">
              <div className="flex flex-wrap gap-2  items-center  justify-end w-full">
                <button
                  onClick={() => {
                    setData([]);
                  }}
                  className="px-6 py-2 border border-gray-200 rounded-md text-sm hover:bg-red-500 hover:text-white  transition"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    uploaduserdata();
                  }}
                  className="ml-[5px] px-6 py-2 border border-gray-200 rounded-md text-sm hover:bg-[#1E293B] hover:text-white hover:border-[#1E293B] transition"
                >
                  Upload
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BulkUploadDeals;
